/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import Magnific from '../vendors/magnific-popup.js';
import Organic from '../vendors/organic-tabs.js';
import gsap from '../vendors/gsap.min';
import '../vendors/InertiaPlugin.min';
import Draggable from '../vendors/Draggable.min';
import SplitText from '../vendors/SplitText.min';
import ScrollTrigger from '../vendors/ScrollTrigger.min';
import DrawSVGPlugin from '../vendors/DrawSVGPlugin.min';
import '../vendors/slick.min';
import '../vendors/masonry.pkgd';
import '../vendors/masonry-layout.min';
import OwlCarousel from '../vendors/owl.carousel.min';
import Swiper from '../vendors/swiper-bundle.min';

// if ( jQuery( '.filtered__links' ).length > 0 ) {
// 	if ( jQuery( window ).width() < 748 ) {
// 		window.addEventListener( 'DOMContentLoaded', function() {
// 			const selectElement = document.createElement( 'select' );
// 			const options = document.querySelectorAll(
// 				'.filtered__links h2 span'
// 			);

// 			options.forEach( function( option, index ) {
// 				const value = option.textContent.trim();

// 				// Check if the option contains '/' and remove it
// 				const optionText = value.includes( '/' )
// 					? value.split( '/' )[ 0 ].trim()
// 					: value;

// 				if ( optionText !== '' ) {
// 					const optionElement = document.createElement( 'option' );
// 					optionElement.value = index;
// 					optionElement.textContent = optionText;

// 					selectElement.appendChild( optionElement );
// 				}
// 			} );

// 			selectElement.addEventListener( 'change', function() {
// 				const selectedIndex = this.selectedIndex;
// 				const selectedOption = options[ selectedIndex ];

// 				// Perform desired action when an option is selected
// 				console.log( 'Selected:', selectedOption.textContent.trim() );
// 			} );

// 			const containerElement = document.querySelector( '.filtered__links' );
// 			containerElement.innerHTML = ''; // Clear existing HTML
// 			containerElement.appendChild( selectElement );
// 		} );
// 	}
// }

jQuery( document ).on( 'scroll', function() {
	if ( jQuery( 'body' ).hasClass( 'page-template-template-impact' ) ) {
		jQuery( 'html' ).addClass( 'remove-overflow-y' );
	}

	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );

setTimeout( () => {
	if ( jQuery( window ).width() > 747 ) {
		if ( jQuery( 'body' ).hasClass( 'page-template-template-ppc' ) ) {
			jQuery( document ).ready( function() {
				jQuery( window ).scroll( function() {
					const buttonOffset = jQuery( '.chck-pnt-for-stky-btn' ).offset().top + jQuery( '.chck-pnt-for-stky-btn' ).outerHeight();
					const scrollTop = jQuery( window ).scrollTop();

					if ( scrollTop >= buttonOffset ) {
						jQuery( '.header-section .jumplink-buttons' ).addClass( 'active' );
					} else {
						jQuery( '.header-section .jumplink-buttons' ).removeClass( 'active' );
					}
				} );
			} );
		}
	}
}, 500 );

jQuery( function() {
	// Member Content

	//

	// Impact Header

	if ( jQuery( '.header__jumplinks--bar' ).length > 0 ) {
		jQuery( '.header__jumplinks--head' ).on( 'click', function() {
			if ( jQuery( window ).width() < 1003 ) {
				jQuery( 'body' ).toggleClass( 'active-dropdown' );
			}
			if ( jQuery( this ).parent().hasClass( 'active' ) ) {
				jQuery( this ).parent().removeClass( 'active' );
				jQuery( this ).siblings( '.header__jumplinks--links' ).slideUp( 300 );
			} else {
				jQuery( '.header__jumplinks--head' ).removeClass( 'active' );
				jQuery( this ).parent().addClass( 'active' );
				jQuery( '.header__jumplinks--links' ).slideUp();
				jQuery( this ).siblings( '.header__jumplinks--links' ).slideDown( 300 );
			}
		} );
	}

	// Impact Header

	if ( jQuery( '.stats' ).length > 0 ) {
		const a = [];
		function isElementInViewport( el ) {
			const rect = el.getBoundingClientRect();
			return rect.bottom > 0 && rect.right > 0 && rect.left < ( window.innerWidth || document.documentElement.clientWidth ) && rect.top < ( window.innerHeight || document.documentElement.clientHeight );
		}
		jQuery( window ).on( 'scroll', function() {
			jQuery( '.stats' ).each( function( index ) {
				if ( ! a[ index ] && isElementInViewport( this ) ) {
					jQuery( this ).find( '.stats-item__number' ).each( function() {
						const $this = jQuery( this ),
							countTo = $this.attr( 'data-number' );
						jQuery( {
							countNum: $this.text(),
						} ).animate( {
							countNum: countTo,
						}, {
							duration: 5000,
							easing: 'swing',
							step() {
								$this.text( Math.ceil( this.countNum ).toLocaleString( 'en' ) );
							},
							complete() {
								$this.text( Math.ceil( this.countNum ).toLocaleString( 'en' ) );
							},
						} );
					} );
					a[ index ] = true;
				}
			} );
		} );

		// Trigger scroll event on initial page load to check if elements are in viewport.
		jQuery( window ).trigger( 'scroll' );
	}

	if ( jQuery( '#top-bar-ajax' ).length > 0 ) {
		jQuery( '#top-bar-ajax' ).topBar();
	}

	if ( jQuery( '.team-variation' ).length > 0 ) {
		jQuery( '.team-grid-members a' ).mouseenter( function() {
			const targetId = jQuery( this ).attr( 'href' ).substring( 1 );
			jQuery( '.team-grid__item' ).removeClass( 'show-bg' );
			jQuery( '.team-grid__item' ).not( jQuery( this ).closest( '.team-grid__item' ) ).addClass( 'show-bg' );
			jQuery( '.grid-initial-content' ).removeClass( 'show' );
			jQuery( '#' + targetId ).addClass( 'show' );
		} );

		jQuery( '.team-grid-members a' ).click( function( event ) {
			event.preventDefault();
		} );

		jQuery( '.team-grid-members a' ).mouseleave( function() {
			jQuery( '.grid-initial-content' ).removeClass( 'show' );
			jQuery( '.grid-initial-content:first-child' ).addClass( 'show' );
		} );

		jQuery( '.team-grid-members a' ).mouseleave( function() {
			jQuery( '.team-grid__item' ).removeClass( 'show-bg' ).removeClass( 'show-bg' );
		} );
	}

	// setTimeout( () => {
	// 	jQuery( 'h1' ).css( {
	// 		opacity: 1,
	// 		visibility: 'visible',
	// 	} );

	// 	if ( jQuery( 'h1:not(.hero-home h1' ).length > 0 ) {
	// 		gsap.registerPlugin( SplitText );

	// 		const heroTitle = document.querySelectorAll( 'h1:not(.hero-home h1)' );
	// 		gsap.registerPlugin( SplitText );

	// 		let textAnim;

	// 		const doText = () => {
	// 			textAnim && textAnim.progress( 1 );
	// 			const text = new SplitText( 'h1:not(.hero-home h1)', { types: 'lines', linesClass: 'lineChild' } );
	// 			const mask = new SplitText( 'h1:not(.hero-home h1)', { types: 'lines', linesClass: 'lineParent' } );

	// 			textAnim = gsap.fromTo( '.lineChild', { yPercent: 200 }, {
	// 				yPercent: 0,
	// 				duration: 0.5,
	// 				stagger: 0.05,
	// 			} );
	// 		};
	// 		doText();
	// 	}
	// }, 500 );

	if ( jQuery( 'body' ).hasClass( 'page-template-template-work-list' ) ) {
		// Add the class to the HTML element
		jQuery( 'html' ).addClass( 'scroll-behavior-normal' );
	}
	if ( jQuery( 'body' ).hasClass( 'single-post' ) ) {
		// Add the class to the HTML element
		jQuery( 'html' ).addClass( 'overflow-normal' );
	}

	// Function to set up custom cursor for a swiper-container
	function setupCustomCursor( slider ) {
		const cursor = document.querySelector( '.cursor-move' );
		const cursorDot = cursor.querySelector( '.cursor-dot' );
		function moveCursor( event ) {
			cursor.style.transform = `translate3d(calc(${ event.clientX }px - 50vw), calc(${ event.clientY }px - 50vh), 0)`;
		}

		// To reset the transition after the movement is done
		function resetTransition() {
			cursor.style.transition = 'none';
		}

		// Attach event listeners
		document.addEventListener( 'mousemove', moveCursor );
		document.addEventListener( 'transitionend', resetTransition );
		slider.addEventListener( 'mousemove', ( event ) => {
			moveCursor( event );
		} );
		slider.addEventListener( 'pointermove', ( event ) => {
			moveCursor( event );
		} );
		slider.addEventListener( 'mouseenter', () => {
			cursorDot.classList.add( 'show' );
		} );
		slider.addEventListener( 'mouseleave', () => {
			cursorDot.classList.remove( 'show' );
		} );
		slider.addEventListener( 'pointerdown', () => {
			cursorDot.classList.add( 'active' );
		} );
		slider.addEventListener( 'pointerup', () => {
			cursorDot.classList.remove( 'active' );
		} );
	}
	// Get all swiper-containers and apply custom cursor logic to each
	const swiperContainers = document.querySelectorAll(
		'.image-slider .image-swiper'
	);
	swiperContainers.forEach( ( slider ) => {
		setupCustomCursor( slider );
	} );

	jQuery.noConflict();

	if ( jQuery( '.swiper-container' ).length > 0 ) {
		const mySwiper = new Swiper( '.swiper-container', {
			// Optional parameters
			slidesPerView: 'auto',
			spaceBetween: 0,
			freeMode: true,
			// grabCursor: false,
			parallax: false,
			watchSlidesVisibility: true,
			loop: false,
			// slideToClickedSlide: true,
			lazy: true,
		} );
	}

	if ( jQuery( window ).width() > 747 ) {
		setTimeout( () => {
			jQuery( '.success' ).masonry( {
				itemSelector: '.success__item',
				gutter: 16,
			} );
		}, 20 );
	}
	setTimeout( () => {
		if ( jQuery( window ).width() > 1003 ) {
			if ( jQuery( '.with-bottom-content' ).length > 0 ) {
				jQuery( '.with-bottom-content' ).find( '.image__slide--img img' ).each( function() {
					const imageWidth = jQuery( this ).width();
					jQuery( this ).parent( '.image__slide--img' ).width( imageWidth );
				} );
			}
		}
	}, 1500 );

	if ( jQuery( window ).width() > 747 ) {
		if ( jQuery( '.quotes-masonry__quote' ).length > 0 ) {
			setTimeout( () => {
				jQuery( '.quotes-masonry' ).masonry( {
					itemSelector: '.quotes-masonry__quote',
					gutter: 12,
				} );
			}, 20 );
			const successBoxes = document.querySelectorAll( '.quotes-masonry__quote' );

			successBoxes.forEach( ( successBox ) => {
				gsap.set( successBox, { opacity: 0, y: 60 } );

				ScrollTrigger.create( {
					trigger: successBox,
					start: 'top 100%', // Adjust this value as needed
					onEnter: () => {
						gsap.to( successBox, {
							opacity: 1,
							y: 0,
							duration: 1,
							ease: 'power2.out',
						} );
					},
				} );
			} );
		}
	}

	jQuery.noConflict();

	if ( ! jQuery( '.footer-section' ).hasClass( 'footer-home-v2' ) ) {
		jQuery( '.footer__socials a' ).each( function() {
			jQuery( this ).html(
				'<span class="icon">' +
				jQuery( this ).html() +
				'</span><span class="circle"><span><em></em></span><span><em></em></span></span>'
			);
		} );
	}
	jQuery.noConflict();

	gsap.registerPlugin( ScrollTrigger );

	if ( jQuery( '.home1.home-hero-section' ).length > 0 ) {
		const playButton = jQuery( '#hero-popup-play' );
		const video = jQuery( '#js-hero-home-iframe' );
		let videoUrl = video.attr( 'src' );
		const videoUrlSimple = video.attr( 'src' );

		playButton.click( function() {
			playButton
				.parents( '.homepage__hero-video' )
				.addClass( 'active-video' );
			video.attr( 'src', '' );
			videoUrl +=
				( videoUrl.includes( '?' ) ? '&' : '?' ) +
				'autoplay=1&rel=0&frameborder=0&t=0';
			video.attr( 'src', videoUrl ); // Autoplay the video

			jQuery( '.homepage-video-main' ).addClass( 'hero-home-iframe-visible' );
		} );

		const videoButton = jQuery( '.video__play-icon' );
		const vimeoPlayer = new Vimeo.Player( 'js-hero-home-iframe' );

		gsap.to( '.homepage-video-close', {
			scrollTrigger: {
				trigger: '.homepage-video-close',
				scrub: true,
				start: 'top -100%',
				end: 'bottom -100%',
				onEnter: () => {
					const video = jQuery( '.js-hero-home-iframe' );
					const $videoMain = jQuery( '.hero-home-iframe-visible' );
					$videoMain.addClass( 'iframe-video-hide' );
					vimeoPlayer.pause();
					const videoUrl = videoUrlSimple;
					video.attr( 'src', '' );
					video.attr( 'src', videoUrl );
				},
				onLeaveBack: () => {
					const $videoMain = jQuery( '.homepage-video-main' );
					$videoMain.removeClass(
						'iframe-video-hide hero-home-iframe-visible'
					);
				},
			},
		} );

		if ( jQuery( window ).width() > 1003 ) {
			const heroCompany = jQuery( '.hero-home' );
			const videoElement = jQuery( '.homepage__hero-video' );
			const videoButton = jQuery( '.video__play-icon' );
			gsap.to( '.home__inner', {
				y: '-100%',
				ease: 'slow',
				opacity: 0,
				scrollTrigger: {
					trigger: '.hero-home',
					scrub: true,
					start: 'top =+150',
					end: 'bottom +=100',
				},
			} );

			const tl = gsap.timeline( {
				ease: 'slow',
				scrollTrigger: {
					trigger: heroCompany,
					start: 'top =+12%',
					end: 'bottom -=150',
					scrub: true,
					pin: true,
					anticipatePin: 1,
					pinSpacing: true,
				},
			} );

			tl.to( videoElement, {
				width: '100%',
				height: '80vh',
				duration: 1,
				y: '-1%',
			} );

			tl.to( videoButton, {
				scale: 1.4,
				scrollTrigger: {
					trigger: heroCompany,
					start: 'top =+12%',
					end: 'bottom -=300',
					scrub: 1,
				},
			} );
		}
	}

	jQuery.noConflict();
	if ( jQuery( '.home2.home-hero-section' ).length > 0 ) {
		if ( jQuery( window ).width() > 1003 ) {
			const heroCompany = jQuery( '.hero-home' );
			const videoElement = jQuery( '.homepage__hero-video' );
			const videoButton = jQuery( '.video__play-icon' );
			gsap.to( '.home__inner', {
				y: '-100%',
				ease: 'slow',
				opacity: 0,
				scrollTrigger: {
					trigger: '.hero-home',
					scrub: true,
					start: 'top =+150',
					end: 'bottom +=100',
				},
			} );

			const tl = gsap.timeline( {
				ease: 'slow',
				scrollTrigger: {
					trigger: heroCompany,
					start: 'top =+12%',
					end: 'bottom -=150',
					scrub: true,
					pin: true,
					anticipatePin: 1,
					pinSpacing: true,
				},
			} );

			tl.to( videoElement, {
				width: '100%',
				height: '80vh',
				duration: 1,
				y: '-1%',
			} );

			tl.to( videoButton, {
				scale: 1.4,
				scrollTrigger: {
					trigger: heroCompany,
					start: 'top =+12%',
					end: 'bottom -=300',
					scrub: 1,
				},
			} );
		}
	}

	jQuery.noConflict();

	if ( jQuery( '.success-quotes' ).length > 0 ) {
		const successBoxes = document.querySelectorAll( '.success__item' );

		successBoxes.forEach( ( successBox ) => {
			gsap.set( successBox, { opacity: 0, y: 60 } );

			ScrollTrigger.create( {
				trigger: successBox,
				start: 'top 100%', // Adjust this value as needed
				onEnter: () => {
					gsap.to( successBox, {
						opacity: 1,
						y: 0,
						duration: 1,
						ease: 'power2.out',
					} );
				},
			} );
		} );
	}

	if ( ! window.location.search.includes( 'mode=light' ) ) {
		if ( jQuery( '.dark-to-light-mode' ).length > 0 ) {
			gsap.to( '.dark-to-light-mode', {
				scrollTrigger: {
					trigger: '.dark-to-light-mode',
					start: 'top center',
					end: 'bottom 120%',
					// markers: true,
					onEnter: () => {
						jQuery( 'body' ).addClass( 'light-mode' );
						jQuery( 'body' ).removeClass( 'dark-mode' );
					},
					onLeaveBack: () => {
						jQuery( 'body' ).removeClass( 'light-mode' );
						jQuery( 'body' ).addClass( 'dark-mode' );
					},
				},
			} );
		}
	}
	jQuery.noConflict();

	// if ( jQuery( '..ctn-black' ).length > 0 ) {
	// 	gsap.to( '..ctn-black', {
	// 		scrollTrigger: {
	// 			trigger: '..ctn-black',
	// 			start: 'top center',
	// 			end: 'bottom 120%',
	// 			// markers: true,
	// 			onEnter: () => {
	// 				jQuery( 'body' ).addClass( 'light-mode' );
	// 				jQuery( 'body' ).removeClass( 'dark-mode' );
	// 			},
	// 			onLeaveBack: () => {
	// 				jQuery( 'body' ).removeClass( 'light-mode' );
	// 				jQuery( 'body' ).addClass( 'dark-mode' );
	// 			},
	// 		},
	// 	} );
	// }
	// jQuery.noConflict();

	if ( jQuery( '.footer-home-v2' ).length > 0 ) {
		gsap.to( '.footer-home-v2', {
			scrollTrigger: {
				trigger: '.footer-home-v2',
				start: 'top top',
				end: 'bottom 120%',
				// markers: true,
				onEnter: () => {
					jQuery( '.header-section' ).addClass( 'hide-fixed-button' );
				},
				onLeaveBack: () => {
					jQuery( '.header-section' ).removeClass( 'hide-fixed-button' );
				},
			},
		} );
	}
	jQuery.noConflict();

	if ( ! window.location.search.includes( 'mode=light' ) ) {
		if ( jQuery( '.light-to-gray-mode-start' ).length > 0 ) {
			gsap.to( '.light-to-gray-mode-start', {
				scrollTrigger: {
					trigger: '.light-to-gray-mode-start',
					start: 'top 60%',
					end: 'bottom 30%',
					// markers: true,
					onEnter: () => {
						jQuery( 'body' ).addClass( 'gray-mode' );
						jQuery( 'body' ).removeClass( 'light-mode' );
					},
					onLeaveBack: () => {
						jQuery( 'body' ).removeClass( 'gray-mode' ).addClass( 'light-mode' );
					},
				},
			} );
		}

		if ( jQuery( '.gray-to-light-mode-end' ).length > 0 ) {
			gsap.to( '.gray-to-light-mode-end', {
				scrollTrigger: {
					trigger: '.gray-to-light-mode-end',
					start: 'top 30%',
					end: 'bottom 30%',
					// markers: true,
					onEnter: () => {
						jQuery( 'body' ).addClass( 'light-mode' );
						jQuery( 'body' ).removeClass( 'gray-mode' );
					},
					onLeaveBack: () => {
						jQuery( 'body' ).removeClass( 'light-mode' ).addClass( 'gray-mode' );
					},
				},
			} );
		}

		if ( ( jQuery( '.light-to-dark-mode-start' ) ) && ( jQuery( '.dark-to-light-mode-end' ) ) ) {
			const darkToLight = jQuery( '.impact-header' ).outerHeight();
			if ( jQuery( '.light-to-dark-mode-start' ).length > 0 ) {
				gsap.to( '.light-to-dark-mode-start', {
					scrollTrigger: {
						trigger: '.light-to-dark-mode-start',
						start: `top ${ darkToLight } top`,
						end: `top ${ darkToLight } top`,
						// markers: true,
						onEnter: () => {
							jQuery( 'body' ).addClass( 'dark-mode' );
							jQuery( 'body' ).removeClass( 'light-mode' );
						},
						onLeaveBack: () => {
							jQuery( 'body' ).removeClass( 'dark-mode' ).addClass( 'light-mode' );
						},
					},
				} );
			}

			if ( jQuery( '.dark-to-light-mode-end' ).length > 0 ) {
				gsap.to( '.dark-to-light-mode-end', {
					scrollTrigger: {
						trigger: '.dark-to-light-mode-end',
						start: `top ${ darkToLight } top`,
						end: `top ${ -darkToLight } top`,
						// markers: true,
						onEnter: () => {
							jQuery( 'body' ).addClass( 'light-mode' );
							jQuery( 'body' ).removeClass( 'dark-mode' );
						},
						onLeaveBack: () => {
							jQuery( 'body' ).removeClass( 'light-mode' ).addClass( 'dark-mode' );
						},
					},
				} );
			}
			jQuery.noConflict();
		}

		if ( jQuery( '.ip-cc' ).length > 0 && !jQuery('body').hasClass("no-change")) {
			gsap.to( '.ip-cc', {
				scrollTrigger: {
					trigger: '.ip-cc',
					start: 'top 30%',
					end: 'bottom 120%',
					// markers: true,
					onEnter: () => {
						jQuery( 'body' ).addClass( 'light-mode' );
						jQuery( 'body' ).removeClass( 'dark-mode' );
					},
					onLeaveBack: () => {
						jQuery( 'body' ).removeClass( 'light-mode' );
						jQuery( 'body' ).addClass( 'dark-mode' );
					},
				},
			} );
		}
		jQuery.noConflict();

		if ( jQuery( '.ip-cc-center' ).length > 0 && !jQuery('body').hasClass("no-change")) {
			gsap.to( '.ip-cc-center', {
				scrollTrigger: {
					trigger: '.ip-cc-center',
					start: 'top center',
					end: 'bottom 120%',
					// markers: true,
					onEnter: () => {
						jQuery( 'body' ).addClass( 'light-mode' );
						jQuery( 'body' ).removeClass( 'dark-mode' );
					},
					onLeaveBack: () => {
						jQuery( 'body' ).removeClass( 'light-mode' );
						jQuery( 'body' ).addClass( 'dark-mode' );
					},
				},
			} );
		}
	}
	jQuery.noConflict();

	jQuery( '.services__navigation ul li' ).click( function() {
		jQuery( '.services__navigation ul li' ).removeClass( 'active' );
		jQuery( this ).addClass( 'active' );

		const windowWidth = jQuery( window ).width();
		let overlayLeft = 0;

		if ( windowWidth < 748 ) {
			overlayLeft = jQuery( this ).prevAll().length * 162;
		} else if ( windowWidth >= 748 && windowWidth < 1004 ) {
			overlayLeft = jQuery( this ).prevAll().length * 188;
		} else {
			overlayLeft = jQuery( this ).prevAll().length * 196;
		}

		if ( windowWidth < 1004 ) {
			jQuery( '.navigation-tab-overlay' ).css( {
				left: overlayLeft + 4 + 'px',
			} );
		} else {
			jQuery( '.navigation-tab-overlay' ).css( {
				left: overlayLeft + 5 + 'px',
			} );
		}
	} );

	jQuery.noConflict();

	// if ( jQuery( '.vision-cards' ).length > 0 ) {
	// 	if ( jQuery( window ).width() < 1180 ) {
	// 		( function( o, i ) {
	// 			typeof exports === 'object' && typeof module < 'u' ? i( exports ) : typeof define === 'function' && define.amd ? define( [ 'exports' ], i ) : ( o = typeof globalThis < 'u' ? globalThis : o || self, i( o.aat = {} ) );
	// 		}( this, function( o ) {
	// 			'use strict'; function i( s, e, t ) {
	// 				return Math.min( Math.max( s, e ), t );
	// 			} function l( { from: s, to: e, percentage: t, unit: n } ) {
	// 				return s + ( e - s ) * t + ( n || '' );
	// 			} const a = { offsetBottom: 0, offsetTop: 0, offsetRight: 0, offsetLeft: 0, addWrapper: ! 1, wrapperClass: '', container: document.documentElement }; class c {
	// 				static Container( e = document.documentElement ) {
	// 					return new h( e );
	// 				} static Element( e, t ) {
	// 					return new d( e, { ...a, ...t } );
	// 				} onScroll( e ) {
	// 					this._handler = e, this._onScroll();
	// 				}
	// 			} class h extends c {
	// 				constructor( e ) {
	// 					super(), this._container = e, ( e === document.documentElement ? window : e ).addEventListener( 'scroll', this._onScroll.bind( this ) );
	// 				} _onScroll() {
	// 					const e = this._container.scrollTop,
	// 						t = this._container.scrollHeight - this._container.clientHeight,
	// 						n = i( e / t, 0, 1 ) || 0,
	// 						r = this._container.scrollLeft,
	// 						p = this._container.scrollWidth - this._container.clientWidth,
	// 						_ = i( r / p, 0, 1 ) || 0; this._handler && typeof this._handler === 'function' && requestAnimationFrame( () => this._handler( { percentageY: n, percentageX: _ } ) );
	// 				}
	// 			} class d extends c {
	// 				constructor( e, t ) {
	// 					super(), this._element = e, this._options = t, this._lastPercentageY = null, this._lastPercentageX = null, this._options.addWrapper && this._addWrapper(), ( this._options.container === document.documentElement ? window : this._options.container ).addEventListener( 'scroll', this._onScroll.bind( this ) ), requestAnimationFrame( () => this._onScroll() );
	// 				} _addWrapper() {
	// 					this._wrapper = document.createElement( 'div' ), this._options.wrapperClass && this._wrapper.classList.add( this._options.wrapperClass ), this._element.parentNode.insertBefore( this._wrapper, this._element ), this._wrapper.appendChild( this._element );
	// 				} get _containerClientHeight() {
	// 					return this._options.container === window ? window.innerHeight : this._options.container.clientHeight;
	// 				} get _containerClientWidth() {
	// 					return this._options.container === window ? window.innerWidth : this._options.container.clientWidth;
	// 				} get _elRectRelativeToContainer() {
	// 					const t = ( this._options.addWrapper ? this._wrapper : this._element ).getBoundingClientRect(); if ( this._options.container === document.documentElement ) {
	// 						return t;
	// 					} const n = this._options.container.getBoundingClientRect(); return { width: t.width, height: t.width, left: t.left - n.left, top: t.top - n.top, right: t.right - n.right, bottom: t.bottom - n.bottom };
	// 				} _calculatePercentageY() {
	// 					const e = this._elRectRelativeToContainer,
	// 						t = this._containerClientHeight - this._options.offsetBottom,
	// 						n = this._options.offsetTop,
	// 						r = t - n; return i( ( t - e.top ) / r, 0, 1 );
	// 				} _calculatePercentageX() {
	// 					const e = this._elRectRelativeToContainer,
	// 						t = this._containerClientWidth - this._options.offsetRight,
	// 						n = this._options.offsetLeft,
	// 						r = t - n; return i( ( t - e.left ) / r, 0, 1 );
	// 				} _onScroll() {
	// 					const e = this._calculatePercentageY(),
	// 						t = this._calculatePercentageX(); this._handler && typeof this._handler === 'function' && ( this._lastPercentageY !== e || this._lastPercentageX !== t ) && requestAnimationFrame( () => this._handler( { percentageY: e, percentageX: t } ) ), this._lastPercentageY = e, this._lastPercentageX = t;
	// 				}
	// 			} o.ScrollObserver = c, o.valueAtPercentage = l, Object.defineProperty( o, Symbol.toStringTag, { value: 'Module' } );
	// 		} ) );

	// 		const { ScrollObserver, valueAtPercentage } = aat;

	// 		const cardsContainer = document.querySelector( '.vision-cards' );
	// 		const cards = document.querySelectorAll( '.vision-card' );
	// 		cardsContainer.style.setProperty( '--cards-count', cards.length );
	// 		cardsContainer.style.setProperty(
	// 			'--card-height',
	// 			`${ cards[ 0 ].clientHeight }px`
	// 		);
	// 		Array.from( cards ).forEach( ( card, index ) => {
	// 			const offsetTop = 0 + index * 40;
	// 			card.style.top = `${ offsetTop }px`;
	// 			if ( index === cards.length - 1 ) {
	// 				return;
	// 			}
	// 			const toScale = 1 - ( cards.length - 1 - index ) * 0.05;
	// 			const nextCard = cards[ index + 1 ];
	// 			const cardInner = card.querySelector( '.vision-card ' );
	// 			ScrollObserver.Element( nextCard, {
	// 				offsetTop,
	// 				offsetBottom: window.innerHeight - card.clientHeight,
	// 			} ).onScroll( ( { percentageY } ) => {
	// 				cardInner.style.scale = valueAtPercentage( {
	// 					from: 1,
	// 					to: toScale,
	// 					percentage: percentageY,
	// 				} );
	// 				cardInner.style.filter = `brightness(${ valueAtPercentage( {
	// 					from: 1,
	// 					to: 1,
	// 					percentage: percentageY,
	// 				} ) })`;
	// 			} );
	// 		} );
	// 	}
	// }

	if ( jQuery( window ).width() > 1003 ) {
		let lastScrollTop = 0,
			delta = 15;
		jQuery( window ).scroll( function( event ) {
			const st = jQuery( this ).scrollTop();

			if ( Math.abs( lastScrollTop - st ) <= delta ) {
				return;
			}
			if ( st > lastScrollTop && lastScrollTop > 0 ) {
				jQuery( 'header' ).addClass( 'nav-up' );
				jQuery( 'header' ).removeClass( 'nav-down' );
			} else {
				jQuery( 'header' ).removeClass( 'nav-up' );
				jQuery( 'header' ).addClass( 'nav-down' );
			}
			lastScrollTop = st;
		} );
	}
	jQuery.noConflict();

	if ( jQuery( window ).width() > 1003 ) {
		jQuery( '.hover__images--ctn a' ).mouseenter( function() {
			jQuery( '.hover__images--ctn' ).find( '.images' ).removeClass( 'active' );
			const dataId = jQuery( this ).parent().attr( 'id' );
			jQuery( '[data-id="' + dataId + '"]' ).addClass( 'active' );
		} );
		jQuery.noConflict();

		jQuery( document ).on( 'mouseover', function( e ) {
			const container = jQuery( '.hover__images--ctn' );
			if (
				! container.is( e.target ) &&
				container.has( e.target ).length === 0
			) {
				container.find( '.images' ).removeClass( 'active' );
			}
		} );
		jQuery.noConflict();
	}

	setTimeout( () => {
		jQuery( 'input[type="file"]' ).each( function() {
		// get label text
			const label = jQuery( this )
				.parents( '.hs-fieldtype-file' )
				.find( 'label' )
				.text();
			// label = label ? label : 'Upload File';

			// wrap the file input
			jQuery( this ).wrap( '<div class="input-file"></div>' );
			// display label
			jQuery( this ).before( '<span class="input-btn">' + 'Upload a file' + '</span>' );
			// we will display selected file here
			jQuery( this ).before( '<span class="file-selected"></span>' );

			// file input change listener
			jQuery( this ).change( function( e ) {
			// Get this file input value
				const val = jQuery( this ).val();

				// Let's only show filename.
				// By default file input value is a fullpath, something like
				// C:\fakepath\Nuriootpa1.jpg depending on your browser.
				const filename = val.replace( /^.*[\\\/]/, '' );

				// Display the filename
				jQuery( this ).siblings( '.file-selected' ).text( filename );
			} );
		} );
	}, 1000 );

	jQuery.noConflict();

	jQuery( '.input-file .btn' ).click( function() {
		jQuery( this ).siblings( 'input[type="file"]' ).trigger( 'click' );
	} );

	jQuery.noConflict();

	if ( jQuery( window ).width() > 1003 ) {
		const menuItems = document.querySelectorAll(
			'.header__nav li, .header__buttons, .footer__nav li a, .footer__legal-nav li'
		);

		menuItems.forEach( ( item ) => {
			item.addEventListener( 'mouseover', () => {
				item.classList.add( 'translate-up' );
			} );

			item.addEventListener( 'mouseout', () => {
				item.classList.remove( 'translate-up' );
			} );
		} );
	}
	jQuery.noConflict();

	if ( jQuery( '#progressbar' ).length > 0 ) {
		const progressBar = document.getElementById( 'progressbar' );
		progressBar.style.height = '1%';

		window.onscroll = () => {
			const scroll = document.documentElement.scrollTop;
			const sections = document.getElementsByClassName( 'page-section' );
			const currentSection = getCurrentSection( sections, scroll );
			const sectionHeight = currentSection.offsetHeight;
			const totalHeight =
				document.documentElement.scrollHeight - sectionHeight;

			const scrolled = ( scroll / totalHeight ) * 100;

			if ( scrolled <= 1 ) {
				// progressBar.style.height = "28%";
			} else if ( scrolled >= 2 && scrolled <= 99.9 ) {
				progressBar.style.height = scrolled + '%';
				progressBar.classList.remove( 'glow' );
			} else if ( scrolled === 100 ) {
				progressBar.style.height = '100%';
			}
		};

		function getCurrentSection( sections, scroll ) {
			for ( let i = 0; i < sections.length; i++ ) {
				const section = sections[ i ];
				const sectionTop = section.offsetTop;
				const sectionBottom = sectionTop + section.offsetHeight;

				if ( scroll >= sectionTop && scroll <= sectionBottom ) {
					return section;
				}
			}

			// Return the first section if no current section found
			return sections[ 0 ];
		}
	}
	jQuery.noConflict();

	if ( jQuery( '#top-bar-ajax' ).length > 0 ) {
		jQuery( '#top-bar-ajax' ).topBar();
	}
	jQuery.noConflict();

	/**
	 * Toggle menu for mobile
	 */

	jQuery( '.menu-item-has-children > a' )
		.focus( function() {
			jQuery( this ).siblings( '.sub-menu' ).addClass( 'focused' );
		} )
		.blur( function() {
			jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
		} );
	jQuery.noConflict();

	/**
	 * Menu btn
	 */

	jQuery( '.menu-btn' ).click( function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );
	jQuery.noConflict();

	jQuery( document ).on( 'click', '.work__filter--select', function() {
		if ( jQuery( this ).hasClass( 'active' ) ) {
			jQuery( this ).removeClass( 'active' );
		} else {
			jQuery( this ).addClass( 'active' );
		}
		if ( jQuery( '.work__filter--options' ).hasClass( 'active' ) ) {
			jQuery( '.work__filter--options' ).removeClass( 'active' );
		} else {
			jQuery( '.work__filter--options' ).addClass( 'active' );
		}
	} );
	jQuery.noConflict();

	jQuery( document ).on( 'click', '.work__filter--options', function() {
		jQuery( '.work__filter--select' ).removeClass( 'active' );
	} );
	jQuery.noConflict();

	jQuery( document ).on( 'click', function( event ) {
		const target = jQuery( event.target );
		if (
			! target.closest( '.work__filter--options' ).length &&
			! target.hasClass( 'work__filter--select' )
		) {
			jQuery( '.work__filter--options' ).removeClass( 'active' );
			jQuery( '.work__filter--select' ).removeClass( 'active' );
		}
	} );
	jQuery.noConflict();

	jQuery( '.video a, .hero-video' ).magnificPopup( {
		// disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: true,
		overflowY: 'hidden',
		callbacks: {
			open() {
				// Add ARIA attributes when the popup is opened
				jQuery( '.mfp-content' ).attr( {
					'aria-modal': 'true',
					role: 'dialog',
				} );
			},
		},
	} );

	jQuery.noConflict();

	jQuery( '.popup-video-button' ).magnificPopup( {
		// disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: true,
		overflowY: 'hidden',
		callbacks: {
			open() {
				// Add ARIA attributes when the popup is opened
				jQuery( '.mfp-content' ).attr( {
					'aria-modal': 'true',
					role: 'dialog',
				} );
			},
		},
	} );

	/**
	 * Team Popup and Footer popup for single work detail
	 */

	if ( jQuery( '.team__detail,.popup-ctn' ).length > 0 ) {
		jQuery( document ).mouseup( function( e ) {
			const container = jQuery( '.team__detail,.popup-ctn' );
			// if the target of the click isn't the container nor a descendant of the container
			if ( ! container.is( e.target ) && container.has( e.target ).length === 0 ) {
				jQuery( '.team__detail,.popup-ctn' ).removeClass( 'show' );
				jQuery( 'body' ).removeClass( 'show' );

				if ( ! jQuery( 'html' ).hasClass( 'overflow-normal' ) ) {
					jQuery( 'html' ).css( 'overflow-y', 'scroll' );
				}

				// jQuery( 'html' ).css( 'overflow-y', 'scroll' );
				jQuery( 'html' ).css( 'margin-right', '0' );
			}
		} );
		jQuery.noConflict();
	}

	if ( jQuery( '.open-popup-link,.project-popup-button' ).length > 0 ) {
		jQuery( '.open-popup-link,.project-popup-button' ).on( 'click', function() {
			jQuery( '.team__detail,.popup-ctn' ).removeClass( 'show' );
			jQuery( 'body' ).removeClass( 'show' );
			const id = jQuery( this ).attr( 'href' );
			jQuery( id ).addClass( 'show' );
			jQuery( 'body' ).addClass( 'show' );
			jQuery( 'html' ).addClass( 'show-sidebar' );
			jQuery( 'html' ).css( 'overflow-y', 'hidden' );
			jQuery( 'html' ).css( 'margin-right', '16px' );
		} );
	}

	if ( jQuery( '.close-btn,.popup-close-btn' ).length > 0 ) {
		jQuery( '.close-btn,.popup-close-btn' ).on( 'click', function() {
			jQuery( '.team__detail,.popup-ctn' ).removeClass( 'show' );
			jQuery( 'body' ).removeClass( 'show' );
			jQuery( 'html' ).removeClass( 'show-sidebar' );

			jQuery( 'html' ).css( 'overflow-y', 'scroll' );
			jQuery( 'html' ).css( 'margin-right', '0' );
		} );

		jQuery.noConflict();
	}
	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */

	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first' )
				.after( '<span class="submenu-icon"></span>' );
		}
	} );
	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */

	jQuery( '.header-nav .submenu-icon' ).click( function() {
		const link = jQuery( this );
		const closestUl = link.closest( 'ul' );
		const parallelActiveLinks = closestUl.find( '.active' );
		const closestLi = link.closest( 'li' );
		const linkStatus = closestLi.hasClass( 'active' );
		let count = 0;

		closestUl.find( 'ul' ).slideUp( function() {
			if ( ++count === closestUl.find( 'ul' ).length ) {
				parallelActiveLinks.removeClass( 'active' );
			}
		} );

		if ( ! linkStatus ) {
			closestLi.children( 'ul' ).slideDown();
			closestLi.addClass( 'active' );
		}
	} );

	/**
	 * Pagination Tooltip
	 */
	jQuery( document ).on( 'mouseover', '.pagination__tooltip', function() {
		jQuery( this )
			.parent()
			.find( '.pages-links' )
			.css( { opacity: 1, visibility: 'visible' } );
		// .css( { opacity: 1, visibility: 'visible' } );
	} );

	jQuery( document ).on( 'mouseleave', '.pagination__tooltip', function() {
		jQuery( this )
			.parent()
			.find( '.pages-links' )
			.css( { opacity: 0, visibility: 'hidden' } );
	} );

	/**
	 * Quote Slider
	 */

	if ( jQuery( window ).width() < 599 ) {
		if ( jQuery( '.quotes-swiper-ctn' ).length > 0 ) {
			new Swiper( '.quotes-swiper-ctn', {
				loop: false,
				slidesPerView: 'auto',
				autoHeight: true,
				paginationClickable: true,
			} );
		}
	}

	/**
	 *
	 * * Script for gravity form label swap
	 *
	 *
	 */

	jQuery(
		'input[type="text"],input[type="email"],input[type="tel"],textarea'
	).each( function() {
		jQuery( this ).parent().parent( '.gfield' ).addClass( 'label-down' );
	} );

	jQuery.noConflict();

	setTimeout( () => {
		jQuery( '.hs-form-checkbox span' ).on( 'click', function() {
		// Get the parent element of the checkbox
			const parent = jQuery( this ).parents( '.hs-form-checkbox' );

			jQuery( parent ).toggleClass( 'active' );
		} );
	}, 1000 );

	jQuery.noConflict();

	setTimeout( () => {
		jQuery( 'input[type="text"],input[type="email"],input[type="tel"], textarea' ).each(
			function() {
				jQuery( this ).on( 'focus', function() {
					jQuery( this ).parents( 'div' )
						.siblings( 'label' ).addClass( 'active' );
					jQuery( '.hs-hubspot_owner_id label' ).addClass( 'active' );
					jQuery( this ).parent().addClass( 'active' );
				} );

				jQuery( this ).on( 'blur', function() {
					if ( jQuery( this ).val().length == 0 ) {
						jQuery( this ).parents( 'div' ).siblings( 'label' ).removeClass( 'active' );
						jQuery( '.hs-hubspot_owner_id label' ).removeClass( 'active' );
						jQuery( this ).parent().removeClass( 'active' );
					}
				} );

				if ( jQuery( this ).val() != '' ) {
					jQuery( this ).parents( 'div' ).siblings( 'label' ).addClass( 'active' );
					jQuery( '.hs-hubspot_owner_id label' ).addClass( 'active' );
					jQuery( this ).parent().addClass( 'active' );
				}
			}
		);
	}, 1000 );

	jQuery.noConflict();

	setTimeout( () => {
		jQuery( 'input[type="text"],input[type="email"],input[type="tel"], textarea' ).each(
			function() {
				jQuery( this ).on( 'focus', function() {
					jQuery( this ).parent().parent( '.gfield' ).addClass( 'active' );
				} );

				jQuery( this ).on( 'blur', function() {
					if ( jQuery( this ).val().length == 0 ) {
						jQuery( this )
							.parent()
							.parent( '.gfield' )
							.removeClass( 'active' );
					}
				} );

				if ( jQuery( this ).val() != '' ) {
					jQuery( this ).parent( '.css' ).addClass( 'active' );
				}
			}
		);
	}, 1000 );
	jQuery.noConflict();

	setTimeout( () => {
		autosize();
		function autosize() {
			const text = jQuery( '.hs-fieldtype-textarea' );

			text.each( function() {
				jQuery( this ).attr( 'rows', 1 );
				resize( jQuery( this ) );
			} );

			text.on( 'input', function() {
				resize( jQuery( this ) );
			} );

			function resize( $text ) {
				$text.css( 'height', 'auto' );
				$text.css( 'height', $text[ 0 ].scrollHeight + 'px' );
			}
		}
	}, 2000 );
	jQuery.noConflict();

	setTimeout( () => {
		jQuery( 'textarea' ).each( function() {
			jQuery( this ).on( 'focus', function() {
				jQuery( this ).parent().parent( '.hs-form-field' ).find( 'label' ).addClass( 'active' );
			} );

			jQuery( this ).on( 'blur', function() {
				if ( jQuery( this ).val().length == 0 ) {
					jQuery( this ).parent().parent( '.hs-form-field' ).find( 'label' ).removeClass( 'active' );
				}
			} );

			if ( jQuery( this ).val() != '' ) {
				jQuery( this ).parent( '.css' ).addClass( 'active' );
			}
		} );
	}, 2000 );
	jQuery.noConflict();

	/**
	 *
	 * * Script for Stats
	 *
	 *
	 */

	jQuery( '.hero .stats-item__number' ).each( function() {
		const $this = jQuery( this ),
			countTo = $this.attr( 'data-number' );
		jQuery( {
			countNum: $this.text(),
		} ).animate(
			{
				countNum: countTo,
			},
			{
				duration: 2000,
				// easing: 'swing',
				step() {
					//$this.text(Math.ceil(this.countNum));
					$this.text( Math.ceil( this.countNum ).toLocaleString( 'en' ) );
				},
				complete() {
					$this.text( Math.ceil( this.countNum ).toLocaleString( 'en' ) );
				},
			}
		);
	} );

	if ( jQuery( '.stat-inner-number' ).length > 0 ) {
		jQuery( '.stat-inner-number' ).on( 'mouseenter', function() {
			jQuery( this ).addClass( 'expand-sticker' );
		} );

		jQuery( '.stat-inner-number' ).on( 'mouseleave', function() {
			jQuery( this ).removeClass( 'expand-sticker' );
			jQuery( this ).addClass( 'shrink-sticker' );

			setTimeout( () => {
				jQuery( this ).removeClass( 'shrink-sticker' );
			}, 200 );
		} );
	}
	/**
	 *
	 * * Script for magnific popup
	 *
	 *
	 */

	if ( jQuery( '.theme__video' ).length > 0 ) {
		jQuery( '.theme__video a' ).magnificPopup( {
			type: 'iframe',
			callbacks: {
				open() {
					// Add accessibility attributes when the popup is opened
					jQuery( '.mfp-content' ).attr( {
						'aria-modal': 'true',
						role: 'dialog',
					} );
				},
			},
		} );
	}

	jQuery.noConflict();

	jQuery( document ).on( 'click', '.ajax-reset-btn', function() {
		// Remove 'active' class from all filter items
		jQuery( '.filter-item' ).removeClass( 'active' );
		jQuery( '.filter-tags' ).html( '' );
		const work_type = [];

		const items = {
			work_type,
		};
		if ( history.pushState ) {
			const oldurl =
				window.location.protocol +
				'//' +
				window.location.host +
				window.location.pathname;
			window.history.pushState( { path: oldurl }, '', oldurl );
		}
		const data = {
			action: 'portfolio_filter',
			items,
			nonce: localVars.nonce,
		};
		jQuery( '.work__filter--options' ).removeClass( 'active' );
		// jQuery('#product-ajax-filter').html('');
		jQuery( '.lds-roller' ).show();

		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'post',
			dataType: 'json',
			data,
			success( response ) {
				jQuery( '.product-ajax-filter' ).html( response.html );
				jQuery( '.lds-roller' ).hide();
			},
		} );
	} );
	jQuery.noConflict();

	jQuery( document ).on( 'click', '.filter-item', function() {
		const work_type = [];
		let element = '';
		let count = 1;

		// jQuery('.filter-item.active').removeClass('active'); // Remove 'active' class from previously selected items

		jQuery( this ).addClass( 'active' );
		jQuery( '.filter-tags' ).append(
			'<div class="tags"><span class="tags__item--link filter-item-remove" data-slug="' +
				jQuery( this ).attr( 'data-slug' ) +
				'" data-type="' +
				jQuery( this ).attr( 'data-type' ) +
				'" >' +
				jQuery( this ).find( 'span' ).text() +
				'</span></div>'
		);

		jQuery( '.filter-item.active' ).each( function() {
			const slug = jQuery( this ).attr( 'data-slug' );
			const type = jQuery( this ).attr( 'data-type' );

			if ( type === 'work_type' ) {
				work_type.push( {
					slug,
					type,
				} );
				if ( jQuery( '.filter-item.active' ).length === count ) {
					element += slug;
				} else {
					element += slug + ',';
				}
			}
			count++;
		} );
		if ( history.pushState ) {
			const oldurl =
				window.location.protocol +
				'//' +
				window.location.host +
				window.location.pathname;
			let newurl = oldurl + '?';
			newurl += 'work-type=' + element;
			if ( newurl === oldurl + '?work-type=' ) {
				window.history.pushState( { path: oldurl }, '', oldurl );
			} else {
				window.history.pushState( { path: newurl }, '', newurl );
			}
		}
		const items = {
			work_type,
		};

		const data = {
			action: 'portfolio_filter',
			items,
			nonce: localVars.nonce,
		};
		jQuery( '.work__filter--options' ).removeClass( 'active' );
		// jQuery('#product-ajax-filter').html('');
		jQuery( '.lds-roller' ).show();

		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'post',
			dataType: 'json',
			data,
			success( response ) {
				jQuery( '.product-ajax-filter' ).html( response.html );
				jQuery( '.lds-roller' ).hide();

				RemoveItem();
			},
		} );
	} );
	RemoveItem();
	jQuery.noConflict();

	jQuery( document ).on( 'click', '.ajax-pagination', function() {
		const work_type = [];
		const paged = jQuery( this ).attr( 'data-page' );
		let element = '';
		let count = 1;
		// jQuery('.filter-item.active').removeClass('active'); // Remove 'active' class from previously selected items

		jQuery( this ).addClass( 'active' );

		jQuery( '.filter-item.active' ).each( function() {
			const slug = jQuery( this ).attr( 'data-slug' );
			const type = jQuery( this ).attr( 'data-type' );

			if ( type === 'work_type' ) {
				work_type.push( {
					slug,
					type,
				} );
				if ( jQuery( '.filter-item.active' ).length === count ) {
					element += slug;
				} else {
					element += slug + ',';
				}
			}
			count++;
		} );
		const items = {
			work_type,
		};
		if ( history.pushState ) {
			const oldurl =
				window.location.protocol +
				'//' +
				window.location.host +
				window.location.pathname;
			let newurl = oldurl + '?';
			if ( element !== '' ) {
				newurl += 'work-type=' + element;
			}

			// Assuming you have the currentPage variable defined
			if ( paged !== '' ) {
				if ( newurl === oldurl + '?work-type=' ) {
					newurl += 'current-page=' + paged;
				} else {
					newurl += '&current-page=' + paged;
				}
			}

			if ( newurl === oldurl + '?' || newurl === oldurl ) {
				window.history.pushState( { path: oldurl }, '', oldurl );
			} else {
				window.history.pushState( { path: newurl }, '', newurl );
			}
		}
		const data = {
			action: 'portfolio_filter',
			items,
			paged,
			nonce: localVars.nonce,
		};
		jQuery( '.work__filter--options' ).removeClass( 'active' );
		// jQuery('#product-ajax-filter').html('');
		jQuery( '.lds-roller' ).show();
		jQuery( 'html, body' ).animate(
			{
				scrollTop: jQuery( '#scroll-to-here' ).offset().top - 400,
			},
			2000
		);
		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'post',
			dataType: 'json',
			data,
			success( response ) {
				jQuery( '.product-ajax-filter' ).html( response.html );
				jQuery( '.lds-roller' ).hide();
			},
		} );
	} );
	jQuery.noConflict();

	function RemoveItem() {
		jQuery( document ).on( 'click', '.filter-item-remove', function() {
			const work_type = [];
			let element = '';
			let count = 1;
			jQuery(
				'.filter-item[data-type="' +
					jQuery( this ).attr( 'data-type' ) +
					'"][data-slug="' +
					jQuery( this ).attr( 'data-slug' ) +
					'"]'
			).removeClass( 'active' );
			jQuery( this ).parent().remove();
			jQuery( '.filter-item.active' ).each( function() {
				const slug = jQuery( this ).attr( 'data-slug' );
				const type = jQuery( this ).attr( 'data-type' );

				if ( type === 'work_type' ) {
					work_type.push( {
						slug,
						type,
					} );
					if ( jQuery( '.filter-item.active' ).length === count ) {
						element += slug;
					} else {
						element += slug + ',';
					}
				}
				count++;
			} );
			if ( history.pushState ) {
				const oldurl =
					window.location.protocol +
					'//' +
					window.location.host +
					window.location.pathname;
				let newurl = oldurl + '?';
				newurl += 'work-type=' + element;
				if ( newurl === oldurl + '?work-type=' ) {
					window.history.pushState( { path: oldurl }, '', oldurl );
				} else {
					window.history.pushState( { path: newurl }, '', newurl );
				}
			}
			const items = {
				work_type,
			};

			const data = {
				action: 'portfolio_filter',
				items,
				nonce: localVars.nonce,
			};
			jQuery( '.work__filter--options' ).removeClass( 'active' );
			// jQuery('#product-ajax-filter').html('');
			jQuery( '.lds-roller' ).show();

			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'post',
				dataType: 'json',
				data,
				success( response ) {
					jQuery( '.product-ajax-filter' ).html( response.html );
					jQuery( '.lds-roller' ).hide();
				},
			} );
		} );
	}
	jQuery.noConflict();

	if ( jQuery( 'body' ).hasClass( 'single-post' ) ) {
		let blogHTML = '';
		let count = 1;
		jQuery( '.blog-detail__content' )
			.find( 'h2' )
			.each( function() {
				const id = jQuery( this )
					.text()
					.toLowerCase()
					.replace( /[^a-zA-Z0-9 ]/g, '' )
					.replace( /\s/g, '-' );
				jQuery( this ).replaceWith(
					'<div class="jump-link-post" id="' +
						id +
						'"></div>' +
						jQuery( this ).fullHtml()
				);
				if ( jQuery( this ).text() !== '' ) {
					blogHTML +=
						`<li><a href="#` +
						id +
						`"><span>` +
						pad( parseInt( count ) ) +
						`.</span> ` +
						jQuery( this ).text() +
						`</a></li>`;
					count++;
				}
			} );
		if ( blogHTML == '' ) {
			jQuery( '.blog-detail__sidebar--title' ).hide();
			jQuery( '.heading-lists' ).hide();
		}
		jQuery( '.heading-lists' ).prepend( blogHTML );

		let prevContentId = null;

		jQuery( window ).scroll( function() {
			const headings = document.querySelectorAll( '.jump-link-post' );

			for ( let i = 0; i < headings.length; i++ ) {
				const heading = headings[ i ];
				const headingId = heading.id;
				const headingElement = document.getElementById( headingId );

				if ( isInViewport( headingElement ) ) {
					updateTableOfContents( headingId );
					prevContentId = headingId;
					break;
				}
			}
		} );

		function updateTableOfContents( currentId ) {
			if ( prevContentId ) {
				const prevLink = jQuery(
					'.heading-lists a[href="#' + prevContentId + '"]'
				);
				prevLink.removeClass( 'current' );
			}

			const currentLink = jQuery(
				'.heading-lists a[href="#' + currentId + '"]'
			);
			currentLink.addClass( 'current' );

			prevContentId = currentId;
		}

		function isInViewport( element ) {
			const rect = element.getBoundingClientRect();
			return (
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <=
					( window.innerHeight ||
						document.documentElement.clientHeight ) &&
				rect.right <=
					( window.innerWidth || document.documentElement.clientWidth )
			);
		}
	}
	jQuery.noConflict();

	jQuery.fn.fullHtml = function() {
		const items = [];
		this.each( function() {
			// console.log( elements );
			let html = '';
			const tagName = jQuery( this ).prop( 'tagName' ).toLowerCase();
			const attributes = this.attributes;
			// console.log( attributes );
			html += '<' + tagName + ' ';
			jQuery.each( attributes, function() {
				html += ' ' + this.name + '="' + this.value + '" >';
			} );
			html += jQuery( this ).html() + '</' + tagName + ' >';
			items.push( html );
		} );
		return items;
	};
	jQuery.noConflict();

	jQuery( '.clr-ctn' ).each( function() {
		let html = '';
		const color = jQuery( this ).attr( 'data-color' );
		const bgcolor = jQuery( this ).attr( 'data-bgcolor' );
		const separateLines = extractLinesFromTextNode( this.firstChild );
		for ( const key in separateLines ) {
			const element = separateLines[ key ];
			html +=
				`<span class="clr-area">
						<span class="clr" style="background-color:` +
				bgcolor +
				`"></span>
						<span class="clr-txt" style="color:` +
				color +
				`;">` +
				element +
				`</span>
					</span>`;
		}
		jQuery( this ).html( html );
	} );

	function pad( d ) {
		return d < 10 ? '0' + d.toString() : d.toString();
	}

	function extractLinesFromTextNode( textNode ) {
		if ( textNode.nodeType !== 3 ) {
			throw new Error( 'Lines can only be extracted from text nodes.' );
		}
		textNode.textContent = collapseWhiteSpace( textNode.textContent );

		const textContent = textNode.textContent;
		const range = document.createRange();
		let lines = [];
		let lineCharacters = [];

		for ( let i = 0; i < textContent.length; i++ ) {
			range.setStart( textNode, 0 );
			range.setEnd( textNode, i + 1 );
			const lineIndex = range.getClientRects().length - 1;
			if ( ! lines[ lineIndex ] ) {
				lines.push( ( lineCharacters = [] ) );
			}
			lineCharacters.push( textContent.charAt( i ) );
		}

		lines = lines.map( function operator( characters ) {
			return collapseWhiteSpace( characters.join( '' ) );
		} );

		return lines;
	}

	function collapseWhiteSpace( value ) {
		return value.trim().replace( /\s+/g, ' ' );
	}

	if ( jQuery( '.work__slider' ).length > 0 ) {
		new Swiper( '.work__slider', {
			loop: false,
			slidesPerView: 'auto',
			paginationClickable: true,
			spaceBetween: 10,
			breakpoints: {
				1920: {
					slidesPerView: 3,
					spaceBetween: 36,
				},
				1004: {
					slidesPerView: 3,
					spaceBetween: 36,
				},
				748: {
					slidesPerView: 2,
					spaceBetween: 10,
				},
				480: {
					slidesPerView: 1.75,
					spaceBetween: 10,
				},
			},
		} );
	}
	jQuery.noConflict();

	if ( jQuery( '.success-quotes' ).length > 0 ) {
		if ( jQuery( window ).width() < 747 ) {
			jQuery( '.success__item' ).hide();
			jQuery( '.success__item' ).slice( 0, 13 ).show();
			jQuery( '#seeMore' ).click( function( e ) {
				e.preventDefault();
				jQuery( '.success__item:hidden' ).slice( 0, 13 ).fadeIn( 'slow' );

				if ( jQuery( '.success__item:hidden' ).length == 0 ) {
					jQuery( '#seeMore' ).fadeOut( 'slow' );
				}
			} );
		}
	}
	jQuery.noConflict();

	const buttons = document.querySelectorAll( 'a.button' );
	buttons.forEach( ( button ) => {
		if ( button.getAttribute( 'target' ) === '_blank' ) {
			// Add a class "external" to the element
			button.classList.add( 'external' );
		}
	} );

	jQuery.noConflict();

	jQuery( 'a.team__single--inner' ).click( function() {
		const bgColor = jQuery( this )
			.find( '.team__single--image' )
			.css( 'background-color' );
		const parentElement = jQuery( this )
			.closest( '.team__single' )
			.find( '.team__single--img' );
		parentElement.css( 'background-color', bgColor );
	} );

	gsap.registerPlugin( Draggable );

	const loops2 = gsap.utils.toArray( '.awards-logo-slider ' ).map( ( line, i ) => {
		line.querySelectorAll( '.awards-logo-item' ).forEach( ( item ) => {
			const clone = item.cloneNode( true );
			line.appendChild( clone );
		} );
		const links = line.querySelectorAll( '.awards-logo-item' ),
			tl = horizontalLoop( links, {
				repeat: -1,
				speed: 1 + i * 0.5,
				draggable: true,
				reversed: false,
				paddingRight: parseFloat(
					gsap.getProperty( links[ 0 ], 'marginRight', 'px' )
				),
				scrub: 1,
				// inertia: true,
				// maxDuration: 0.5,
			} );

		links.forEach( ( link ) => {
			link.addEventListener( 'mouseenter', () =>
				gsap.to( tl, { timeScale: 0, overwrite: true } )
			);
			link.addEventListener( 'mouseleave', () =>
				gsap.to( tl, { timeScale: i ? -1 : 1, overwrite: true } )
			);
		} );
	} );

	let currentScroll = 0;
	let scrollDirection = 1;

	window.addEventListener( 'scroll', () => {
		const direction = window.pageYOffset > currentScroll ? 1 : -1;
		if ( direction !== scrollDirection ) {
			loops2.forEach( ( tl ) =>
				gsap.to( tl, { timeScale: direction, overwrite: true } )
			);
			scrollDirection = direction;
		}
		currentScroll = window.pageYOffset;
	} );

	function horizontalLoop( items, config ) {
		items = gsap.utils.toArray( items );
		config = config || {};
		let tl = gsap.timeline( {
				repeat: config.repeat,
				paused: config.paused,
				defaults: { ease: 'none' },
				onReverseComplete: () =>
					tl.totalTime( tl.rawTime() + tl.duration() * 100 ),
			} ),
			length = items.length,
			startX = items[ 0 ].offsetLeft,
			times = [],
			widths = [],
			xPercents = [],
			curIndex = 0,
			pixelsPerSecond = ( config.speed || 1 ) * 100,
			snap =
							config.snap === false
								? ( v ) => v
								: gsap.utils.snap( config.snap || 1 ),
			populateWidths = () =>
				items.forEach( ( el, i ) => {
					widths[ i ] = parseFloat(
						gsap.getProperty( el, 'width', 'px' )
					);
					xPercents[ i ] = snap(
						( parseFloat( gsap.getProperty( el, 'x', 'px' ) ) /
										widths[ i ] ) *
										100 +
										gsap.getProperty( el, 'xPercent' )
					);
				} ),
			getTotalWidth = () =>
				items[ length - 1 ].offsetLeft +
							( xPercents[ length - 1 ] / 100 ) * widths[ length - 1 ] -
							startX +
							items[ length - 1 ].offsetWidth *
								gsap.getProperty( items[ length - 1 ], 'scaleX' ) +
							( parseFloat( config.paddingRight ) || 0 ),
			totalWidth,
			curX,
			distanceToStart,
			distanceToLoop,
			item,
			i;
		populateWidths();
		gsap.set( items, {
			xPercent: ( i ) => xPercents[ i ],
		} );
		gsap.set( items, { x: 0 } );
		totalWidth = getTotalWidth();
		for ( i = 0; i < length; i++ ) {
			item = items[ i ];
			curX = ( xPercents[ i ] / 100 ) * widths[ i ];
			distanceToStart = item.offsetLeft + curX - startX;
			distanceToLoop =
							distanceToStart +
							widths[ i ] * gsap.getProperty( item, 'scaleX' );
			tl.to(
				item,
				{
					xPercent: snap(
						( ( curX - distanceToLoop ) / widths[ i ] ) * 100
					),
					duration: distanceToLoop / pixelsPerSecond,
				},
				0
			)
				.fromTo(
					item,
					{
						xPercent: snap(
							( ( curX - distanceToLoop + totalWidth ) /
											widths[ i ] ) *
											100
						),
					},
					{
						xPercent: xPercents[ i ],
						duration:
										( curX -
											distanceToLoop +
											totalWidth -
											curX ) /
										pixelsPerSecond,
						immediateRender: false,
					},
					distanceToLoop / pixelsPerSecond
				)
				.add( 'label' + i, distanceToStart / pixelsPerSecond );
			times[ i ] = distanceToStart / pixelsPerSecond;
		}
		function toIndex( index, vars ) {
			vars = vars || {};
			Math.abs( index - curIndex ) > length / 2 && ( index += index > curIndex ? -length : length ); // always go in the shortest direction
			let newIndex = gsap.utils.wrap( 0, length, index ),
				time = times[ newIndex ];
			if ( time > tl.time() !== index > curIndex ) {
				// if we're wrapping the timeline's playhead, make the proper adjustments
				vars.modifiers = {
					time: gsap.utils.wrap( 0, tl.duration() ),
				};
				time += tl.duration() * ( index > curIndex ? 1 : -1 );
			}
			curIndex = newIndex;
			vars.overwrite = true;
			return tl.tweenTo( time, vars );
		}
		tl.next = ( vars ) => toIndex( curIndex + 1, vars );
		tl.previous = ( vars ) => toIndex( curIndex - 1, vars );
		tl.current = () => curIndex;
		tl.toIndex = ( index, vars ) => toIndex( index, vars );
		tl.updateIndex = () =>
			( curIndex = Math.round( tl.progress() * ( items.length - 1 ) ) );
		tl.times = times;
		tl.progress( 1, true ).progress( 0, true ); // pre-render for performance
		if ( config.reversed ) {
			tl.vars.onReverseComplete();
			tl.reverse();
		}
		if ( config.draggable && typeof Draggable === 'function' ) {
			let proxy = document.createElement( 'div' ),
				wrap = gsap.utils.wrap( 0, 1 ),
				ratio,
				startProgress,
				draggable,
				dragSnap,
				roundFactor,
				align = () =>
					tl.progress(
						wrap(
							startProgress +
											( draggable.startX - draggable.x ) * ratio
						)
					),
				syncIndex = () => tl.updateIndex();
			typeof InertiaPlugin === 'undefined' &&
							console.warn(
								'InertiaPlugin required for momentum-based scrolling and snapping. https://greensock.com/club'
							);
			draggable = Draggable.create( proxy, {
				trigger: items[ 0 ].parentNode,
				type: 'x',
				onPress() {
					startProgress = tl.progress();
					tl.progress( 0 );
					populateWidths();
					totalWidth = getTotalWidth();
					ratio = 1 / totalWidth;
					dragSnap = totalWidth / items.length;
					roundFactor = Math.pow(
						10,
						( ( dragSnap + '' ).split( '.' )[ 1 ] || '' ).length
					);
					tl.progress( startProgress );
				},
				onDrag: align,
				onThrowUpdate: align,
				inertia: true,
				snap: ( value ) => {
					const n =
									Math.round( parseFloat( value ) / dragSnap ) *
									dragSnap *
									roundFactor;
					return ( n - ( n % 1 ) ) / roundFactor;
				},
				onRelease: syncIndex,
				onThrowComplete: () =>
					gsap.set( proxy, { x: 0 } ) && syncIndex(),
			} )[ 0 ];
		}

		return tl;
	}

	if ( jQuery( window ).width() > 1003 ) {
		if ( jQuery( '.member-feature-text' ).length > 0 ) {
			gsap.registerPlugin( SplitText );

			const split = new SplitText( '.member-feature-text', { type: 'lines' } );
			let masks;
			function makeItHappen() {
				masks = [];
				split.lines.forEach( ( target ) => {
					const mask = document.createElement( 'span' );
					mask.className = 'mask';
					target.append( mask );
					masks.push( mask );
					gsap.to( mask, {
						scaleX: 0,
						transformOrigin: 'right center',
						ease: 'none',
						scrollTrigger: {
							trigger: target,
							scrub: true,
							start: 'top 75%',
							end: 'bottom 75%',
						},
					} );
				} );
			}

			makeItHappen();
		}
	}

	if ( jQuery( '.hjlb__progress' ).length > 0 ) {
		gsap.registerPlugin( DrawSVGPlugin );
		const path = document.getElementById( 'path' );
		gsap.fromTo( path, {
			drawSVG: '0%',
		}, {
			drawSVG: '100%',
			ease: 'none',
			scrollTrigger: {
				trigger: 'body',
				start: 'top top',
				end: 'bottom bottom',
				scrub: true,
				// markers: 'true',
			},
		} );
	}

	setTimeout( () => {
		if ( jQuery( '.single-core-value' ).length > 0 ) {
			jQuery( '.single-core-value' ).each( function() {
				const coreValuesHeight = jQuery( this ).outerHeight() - window.outerHeight + 'px';
				console.log( coreValuesHeight );
				const coreValueImage = jQuery( this ).find( '.core-value-image' );
				gsap.to( coreValueImage, {
					drawSVG: '100%',
					ease: 'none',
					scrollTrigger: {
						trigger: coreValueImage,
						start: 'top 25% top',
						end: `${ coreValuesHeight }`,
						scrub: true,
						pin: true,
						pinSpacing: false,
					},
				} );
			} );
		}
	}, 500 );

	if ( jQuery( '.header__jumplinks--links' ).length > 0 ) {
		jQuery( document ).on( 'click', function( event ) {
			if ( ! jQuery( event.target ).closest( '.header__jumplinks' ).length ) {
				jQuery( '.header__jumplinks--links' ).slideUp();
				jQuery( '.header__jumplinks--bar' ).removeClass( 'active' );
			}
		} );
	}
} );
